import React from 'react';
import { logout } from "../../actions/AuthActions";
import { fetchMendixUser } from "../../actions/UserActions";
import { connect } from "react-redux";
import { url } from '../../utils/const';
import { Redirect, withRouter } from "react-router-dom";

class Menu extends React.Component {

    constructor(props) {
        super(props);

        this.handleOutsideClick = this.handleOutsideClick.bind(this);

        this.state = {
            open: false,
            redirect: null
        };
    }

    async componentDidMount() {
        // Haal Mendix-user op (voor manager / beheer)
        await this.props.fetchMendixUser();
    }

    logout(e) {
        document.removeEventListener("click", this.handleOutsideClick, false);
        e.preventDefault();
        this.props.logout();
    }

    toggleMenu() {
        if (!this.state.open) {
            document.addEventListener("click", this.handleOutsideClick, false);
        } else {
            document.removeEventListener("click", this.handleOutsideClick, false);
        }
        this.setState({ open: !this.state.open });
    }

    handleOutsideClick(e) {
        if (this.node && this.node.contains(e.target)) return;
        this.toggleMenu();
    }

    hours() {
        document.removeEventListener("click", this.handleOutsideClick, false);

        // 👉 Als we in "Alle vakanties" zitten (Layout met showAllHolidays = true),
        // dan moeten we NIET redirecten, maar gewoon de toggle terugzetten.
        if (this.props.showAllHolidays && this.props.toggleAllHolidays) {
            this.props.toggleAllHolidays();        // terug naar uren-overzicht
            this.setState({
                open: false,
                redirect: null
            });
        } else {
            // In alle andere gevallen (bijv. vanaf /holidays) wél naar "/"
            this.setState({ redirect: "/" });
        }
    }

    holidays() {
        document.removeEventListener("click", this.handleOutsideClick, false);
        this.setState({ redirect: "holidays" });
    }

    holidayOverview() {
        document.removeEventListener("click", this.handleOutsideClick, false);

        if (this.props.toggleAllHolidays) {
            this.props.toggleAllHolidays();  // schakelt tussen uren <-> alle vakanties
        }

        this.setState({
            open: false,
            redirect: null
        });
    }

    changePassword() {
        document.removeEventListener("click", this.handleOutsideClick, false);
        this.setState({ redirect: "change-password" });
    }

    clock() {
        // AUTH user bevat het token, niet Mendix-user
        const { auth } = this.props;

        if (auth && auth.authUser && auth.authUser.authenticationToken) {
            document.removeEventListener("click", this.handleOutsideClick, false);

            const token = auth.authUser.authenticationToken;
            this.setState({ redirect: "scan?token=" + token });
        }
    }

    render() {

        // Redirects
        const redirect = this.state.redirect;

        if (redirect) {
            if (redirect === "/") return <Redirect to="/" />;
            if (redirect === "holidays") return <Redirect to="/holidays" />;
            if (redirect === "change-password") return <Redirect to="/change-password" />;
            if (redirect.startsWith("scan")) return <Redirect to={"/" + redirect} />;
        }

        const user = this.props.user;        // Mendix-user direct

        let hours = (
            <li>
                <span className="block clickable" onClick={this.hours.bind(this)}>
                    <i className="fal fa-stopwatch inline-block m-r-sm m-l-sm" />
                    <span>Uren schrijven</span>
                </span>
            </li>
        );

        let holidays = (
            <li>
                <span className="block clickable" onClick={this.holidays.bind(this)}>
                    <i className="fal fa-sun icon inline-block m-r-sm m-l-sm" />
                    <span>Mijn vakanties</span>
                </span>
            </li>
        );

        let holidayOverview = (
            <li>
                <span className="block clickable" onClick={this.holidayOverview.bind(this)}>
                    <i className="fal fa-map icon inline-block m-r-sm m-l-sm" />
                    <span>Alle vakanties</span>
                </span>
            </li>
        );

        let changePassword = (
            <li>
                <span className="block clickable" onClick={this.changePassword.bind(this)}>
                    <i className="fal fa-key inline-block m-r-sm m-l-sm" />
                    <span>Wijzig wachtwoord</span>
                </span>
            </li>
        );

        let logoutItem = (
            <li>
                <span className="block clickable" onClick={this.logout.bind(this)}>
                    <i className="fal fa-sign-out inline-block m-r-sm m-l-sm" />
                    <span>Logout</span>
                </span>
            </li>
        );

        return (
            <div
                className="full-height float-right relative"
                ref={(node) => { this.node = node; }}
            >
                <div className="float-right full-height m-r submenu-trigger-container">
                    <span className="submenu-trigger" onClick={this.toggleMenu.bind(this)}>
                        <i className="fas fa-ellipsis-v white" />
                    </span>
                </div>

                <div className={this.state.open ? "submenu-container" : "closed submenu-container"}>
                    <ul className="card submenu-menu">
                        {hours}
                        {holidays}
                        {holidayOverview}
                        {changePassword}
                        {logoutItem}
                    </ul>
                </div>
            </div>
        );
    }
}

// ⭐ authUser + mendixUser beschikbaar
function mapStateToProps(state) {
    return {
        auth: state.user,           // bevat authUser (zoals je eerder had opgezet)
        user: state.user.mendixUser // Mendix-medewerker
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        { logout, fetchMendixUser }
    )(Menu)
);
